var main_vid_loaded = false;
var videosPerPage = 4; // Number of videos to load per page
var nextPageUrl = "";
function load_vids(url) {
  $.ajax({
    type: "GET",
    url: url,
    success: function (data) {
      var videoCount = 0; // Track the number of videos loaded

      $.each(data.data, function (i, e) {
        var videoTitle = e.name;
        var videoImg = e.pictures.sizes[3].link;
        var videoURI = e.uri;
        var videoID = videoURI.replace("/videos/", "");
        var videoPublic = e.privacy.embed;

        if (videoPublic == "public" && e.privacy.view == "anybody") {
          // Append video item to the grid
          $("<div/>", {
            class:
              "ctm__video__box grid__item grid-product medium--one-half large--one-third",
            "data-src": videoID,
            "data-title": videoTitle,
          })
            .append(
              '<div class="grid-product__image-wrapper"><img src="' +
                videoImg +
                '"><span class="overlay"></span></div>',
            )
            .append(
              '<div class="grid-product__meta"><p class="grid-product__title">' +
                videoTitle +
                "</p></div>",
            )
            .appendTo("#videoGrid");

          videoCount++; // Increment the video count

          if (videoCount >= videosPerPage) {
            return false; // Exit the loop
          }
        }
      });

      $("#videoGrid .grid__item")
        .unbind("click")
        .on("click", function () {
          var mainVideoID = $(this).data("src");
          var mainVideoTitle = $(this).data("title");
          $(".ctm_video_title_text").html(mainVideoTitle);
          $(".vplayer").attr(
            "src",
            "https://player.vimeo.com/video/" +
              mainVideoID +
              "?api=1&player_id=player1&autoplay=1",
          );

          $("html, body").animate({ scrollTop: 0 }, 200);

          return false;
        });

      if (!main_vid_loaded) {
        $("#videoGrid .grid__item").eq(0).trigger("click");
        main_vid_loaded = true;
      }

      if (data.paging && data.paging.next) {
        nextPageUrl = data.paging.next;
        showLoadMoreButton();
      } else {
        hideLoadMoreButton();
      }
    },
  });
}

function showLoadMoreButton() {
  $("#loadMoreBtn").show();
}

function hideLoadMoreButton() {
  $("#loadMoreBtn").hide();
}

$("#loadMoreBtn").click(function () {
  loadMoreVideos();
});

function loadMoreVideos() {
  if (nextPageUrl) {
    load_vids("https://api.vimeo.com" + nextPageUrl);
  }
}

if ($("body").hasClass("template-page-videos")) {
  load_vids(
    "https://api.vimeo.com/users/7251264/videos?access_token=571c45c010ee201f223ce2c248db133a",
  );
}

setTimeout(function () {
  $(".vplayer").css({
    opacity: "1", // Set opacity to 100%
    display: "block", // Set display to block
  });
  $(".loader").css({
    opacity: "1", // Set opacity to 100%
    display: "none", // Set display to block
  });
}, 10000);

// LOCATON GALLERY SLIDER
$(document).ready(function () {
  var swiper = new Swiper(".catch_location_slider", {
    slidesPerView: 2.5,
    loop: true,
    spaceBetween: 40,
    speed: 1000,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    centeredSlides: true,
    centeredSlidesBounds: true,
    navigation: {
      nextEl: ".gallery_aerogrp_next",
      prevEl: ".gallery_aerogrp_prev ",
    },
    breakpoints: {
      1440: {
        slidesPerView: 2.3,
        spaceBetween: 40,
      },
      1280: {
        slidesPerView: 2.3,
        spaceBetween: 35,
      },
      1024: {
        slidesPerView: 2.3,
        spaceBetween: 25,
      },
      768: {
        slidesPerView: 2.3,
        spaceBetween: 25,
      },
      575: {
        slidesPerView: 1.3,
        spaceBetween: 20,
      },
      414: {
        slidesPerView: 1.25,
        spaceBetween: 20,
      },
      0: {
        slidesPerView: 1.25,
        spaceBetween: 20,
      },
    },
  });
});
